import { toast } from "react-hot-toast";

import { loginRequest, msalInstance } from "@/config";

import { TOKEN_ERROR } from "../constant/errorConstants";
import storage from "../storage";

const getMslToken = async () => {
  const account = msalInstance.getAllAccounts()[0];
  let stringToken = storage.getToken();
  if (
    stringToken &&
    JSON.parse(atob(stringToken.split(".")?.[1]))?.exp * 1000 - Date.now() >=
      60000 // ensuring the token doesn't expire at least next 1 min
  ) {
    return stringToken;
  }
  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: loginRequest.scopes,
      account: account,
    });
    stringToken = tokenResponse.accessToken;
    storage.setToken(stringToken);
    return stringToken;
  } catch (error) {
    toast.error(TOKEN_ERROR);
    logOut();
    throw error;
  }
};

const logOut = () => {
  msalInstance.logoutRedirect();
  storage.clearToken();
};

export const MSALAUTH = {
  logOut,
  getMslToken,
};
